export default __webpack_public_path__ + "8ac27062df1ca884aadc7546b45651f5.png";